import { useToggle } from 'react-use';
import styled from 'styled-components';

import { TranslatableText, useFormController } from '@dreryk/react-common';
import { Link, Modal, ModalWidth, Textarea } from '@dreryk/react-components';

type PharmindexIntegrationDetailsCellProps = {
   readonly buttonLabel: TranslatableText;
   readonly content?: string;
   readonly windowTitle: TranslatableText;
};

const StyledTextarea = styled.div`
   min-width: 40em;
   max-width: 100vw;
`;

const PharmindexIntegrationDetailsCell = (props: PharmindexIntegrationDetailsCellProps): JSX.Element | null => {
   const [modalOpen, toggle] = useToggle(false);
   const { register } = useFormController<{ info: string }>({ info: props.content });

   if (!props.content) {
      return null;
   }

   return (
      <>
         <Link label={props.buttonLabel} onClick={toggle} testId={'integrationDetails'} />
         {modalOpen ? (
            <Modal
               title={props.windowTitle}
               onConfirm={toggle}
               onCancel={toggle}
               onCloseRequest={toggle}
               width={ModalWidth.WIDE}
               testId={'integrationDetails'}
            >
               <StyledTextarea>
                  <Textarea
                     focus={false}
                     controller={register('info')}
                     rows={10}
                     maxRows={10}
                     readOnly
                     testId={'info'}
                  />
               </StyledTextarea>
            </Modal>
         ) : null}
      </>
   );
};

export { PharmindexIntegrationDetailsCell };
